import { Box, Paper, Stack, Typography } from '@mui/material';
import LogoKoala from '../assets/images/logo.png';

const PasswordPageShell = ({ icon, title, subtitle, children }) => (
    <Box
        sx={{
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            px: 2,
            py: 4,
            bgcolor: '#edf3f6',
            backgroundImage:
                'radial-gradient(circle at top left, rgba(17,82,111,0.12), transparent 38%)',
        }}
    >
        <Paper
            elevation={0}
            component="main"
            sx={{
                width: '100%',
                maxWidth: 520,
                borderRadius: 3,
                overflow: 'hidden',
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0 24px 70px rgba(27, 55, 68, 0.14)',
            }}
        >
            <Box sx={{ height: 6, bgcolor: '#11526f' }} />
            <Box sx={{ px: { xs: 3, sm: 5 }, py: { xs: 3, sm: 4.5 } }}>
                <Box
                    component="img"
                    src={LogoKoala}
                    alt="Koala"
                    sx={{
                        display: 'block',
                        width: 210,
                        maxWidth: '70%',
                        height: 'auto',
                        mx: 'auto',
                        mb: 3.5,
                    }}
                />
                <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    sx={{ mb: 3 }}
                >
                    <Box
                        sx={{
                            width: 42,
                            height: 42,
                            flex: '0 0 auto',
                            borderRadius: '50%',
                            display: 'grid',
                            placeItems: 'center',
                            bgcolor: 'rgba(17,82,111,0.1)',
                            color: '#11526f',
                        }}
                    >
                        {icon}
                    </Box>
                    <Box>
                        <Typography variant="h5" component="h1">
                            {title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {subtitle}
                        </Typography>
                    </Box>
                </Stack>
                {children}
            </Box>
        </Paper>
    </Box>
);

export default PasswordPageShell;
